import crypto from 'crypto'

const Auth = params => {
  var time = Date.now() / 1000
  params.timestamp = parseInt(time)
  params.security_key = '5c42fe7441dg19b11befb1bgc16d83f9'
  var sdic = Object.keys(params).sort()
  var str = ''
  for (var key in sdic) {
    str = str + sdic[key] + params[sdic[key]]
  }
  var md5 = function (str) {
    var crypto_md5 = crypto.createHash('md5')
    crypto_md5.update(str)
    return crypto_md5.digest('hex')
  }

  var md5Str = md5(str)
  // console.log(str,'md5Str:',md5Str);
  params.sign = md5Str
  delete params.security_key
  return params
}

// 根据key生成加密函数
const AuthFactory = (secuireKey) => {
  return (params) => {
    const time = Date.now() / 1000
    params.timestamp = parseInt(time)
    params.security_key = secuireKey
    const sdic = Object.keys(params).sort()
    let str = ''
    for (var i = 0, len = sdic.length; i < len; i++) {
      str = str + sdic[i] + params[sdic[i]]
    }
    console.log('secure string', str)
    params.sign = crypto.createHash('md5').update(str).digest('hex')
    delete params.security_key
    return params
  }
}

export default {
  Auth,
  TxAuth: AuthFactory('RFoBM22OcTg7neWsm3RPqFzop8wJbHYn')
}
